import React, { useState } from 'react';

const FAQ = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(null);

  if (!items || items.length === 0) return null;

  return (
    <section className="faq-section">
      <h2 className="features-title">Frequently Asked Questions</h2>
      <p className="features-subtitle">Got questions? We've got answers.</p>
      <div className="faq-list">
        {items.map((item, idx) => (
          <div key={idx} className={`faq-item ${openIndex === idx ? 'open' : ''}`}>
            <button className="faq-question" onClick={() => setOpenIndex(openIndex === idx ? null : idx)}>
              <span>{item.question}</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ transform: openIndex === idx ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s' }}>
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            <div className="faq-answer" style={{ maxHeight: openIndex === idx ? '200px' : '0', opacity: openIndex === idx ? 1 : 0 }}>
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
